import { arbitrum, avalanche, bsc, mainnet, polygon } from "wagmi/chains";
export const chains = [arbitrum, mainnet, polygon, bsc, avalanche];
